/*
 * 4-Б6 «Шаблоны сообщений». Геометрия из макета: карточка редактора 640 px, список
 * слева, строка стоимости отдельной полосой, предпросмотр пузырём чата.
 *
 * Ни одного цвета мимо токенов: экран открывают и в тёмной теме, и цена, потерявшая
 * в ней читаемость, — это сумма, которую салон не увидит.
 */

.screen {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4);
  min-width: 0;
}

.head {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.title {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.lead {
  margin: 0;
  max-width: 640px;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
}

/* Список и редактор рядом; на узком экране — друг под другом. */
.layout {
  display: grid;
  grid-template-columns: minmax(220px, 280px) minmax(0, 640px);
  gap: var(--space-4);
  align-items: start;
}

@media (max-width: 900px) {
  .layout {
    grid-template-columns: minmax(0, 1fr);
  }
}

.rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-card);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.rowActive {
  composes: row;
  border-color: var(--accent);
  background: var(--note-bg);
  color: var(--note-fg);
}

.rowTitle {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
}

.rowSub {
  font-size: var(--font-size-xs);
  color: var(--text-secondary);
}

.rowActive .rowSub {
  color: inherit;
}

.editor {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg-card);
  min-width: 0;
}

.editorHead {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.editorHead > div:first-child {
  margin-right: auto;
}

.editorTitle {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.editorSub {
  color: var(--text-secondary);
  font-size: var(--font-size-xs);
}

.field {
  display: block;
  min-width: 0;
}

.area {
  display: block;
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-card);
  color: inherit;
  font: inherit;
  font-size: var(--font-size-sm);
  line-height: 1.6;
  resize: vertical;
}

/* Неизвестная подстановка — единственное, что гасит «Сохранить»; рамка говорит об этом
   раньше текста. Цвет отказа отличается от цвета предупреждения о рекламе: первое
   запрещает сохранение, второе оставляет решение салону, и красить их одинаково значит
   склеить запрет с советом. */
.areaBad {
  composes: area;
  border-color: var(--note-danger-fg);
}

.subs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.hint {
  width: 100%;
  color: var(--text-secondary);
  font-size: var(--font-size-xs);
}

.sub {
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: var(--font-size-xs);
  padding: 2px 8px;
  cursor: pointer;
}

.sub:hover {
  border-color: var(--accent);
}

.cost {
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  line-height: 1.5;
}

.costOk {
  composes: cost;
  background: var(--note-plain-bg);
  color: var(--note-plain-fg);
}

.costWarn {
  composes: cost;
  background: var(--note-bg);
  color: var(--note-fg);
}

.promo {
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border);
  border-left: 3px solid var(--note-fg);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  line-height: 1.5;
}

.promoWhy {
  color: var(--text-secondary);
}

.bad {
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--note-danger-fg);
  border-left: 3px solid var(--note-danger-fg);
  border-radius: var(--radius-md);
  background: var(--note-danger-bg);
  color: var(--note-danger-fg);
  font-size: var(--font-size-sm);
  line-height: 1.5;
}

.previewBox {
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-top: 1px solid var(--border);
  padding-top: var(--space-3);
}

/* Пузырь чата: салон должен увидеть текст так, как его увидит клиент. */
.bubble {
  max-width: 420px;
  padding: 9px 12px;
  border-radius: 14px 14px 14px 4px;
  background: var(--note-plain-bg);
  color: var(--note-plain-fg);
  font-size: var(--font-size-sm);
  line-height: 1.5;
  white-space: pre-wrap;
}

.versions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.version {
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: var(--space-2) var(--space-3);
}

.versionHead {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
  font-size: var(--font-size-sm);
}

.versionWho {
  color: var(--text-secondary);
  font-size: var(--font-size-xs);
  margin-right: auto;
}

.versionNow {
  color: var(--text-secondary);
  font-size: var(--font-size-xs);
}

.versionBody {
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: var(--font-size-xs);
  line-height: 1.5;
}

.note {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.actions {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
